<template>
    <div id="app" :style="conheight">
        <router-view></router-view>
    </div>
</template>
<script>
    import { buildAuthQuery } from '@/utils/authParams.js'

    // 活动页面路径前缀：这些页面在安卓 WebView 中需要强制刷新，不读缓存
    const ACTIVITY_PATHS = ['/activity/', '/inviteFriend']
    // 活动列表页路径
    const ACTIVITY_LIST_PATH = '/activity/list'
    // sessionStorage 键：标记是否从活动列表进入活动详情页
    const FROM_LIST_KEY = 'FROM_ACTIVITY_LIST'

    export default {
      data() {
        return {
          conheight: {height: ''}, //   页面高度
          backIntercepted: false   // 是否已为当前活动详情页设置返回键拦截
        };
      },
      methods: {
        getHeight() {
          this.conheight.height = window.innerHeight + 'px';
        },
        // 判断当前路由是否为活动页面（含列表页和详情页）
        isActivityRoute(path) {
          return ACTIVITY_PATHS.some(p => path.startsWith(p) || path === p)
        },
        // 判断是否为活动详情页（排除列表页）
        isActivityDetail(path) {
          if (path === ACTIVITY_LIST_PATH) return false
          return this.isActivityRoute(path)
        },
        // 为活动详情页设置返回键拦截：按返回键时跳转到活动列表，而不是直接关闭 WebView
        setupBackIntercept(path) {
          // 非活动详情页不拦截，让 WebView 默认行为生效（关闭或后退）
          if (!this.isActivityDetail(path)) {
            this.cleanupBackIntercept()
            return
          }
          // 从活动列表进入详情页时，浏览器默认 back 即可回到列表，无需哨兵拦截
          // 读取并清除标志，避免刷新详情页时误判
          const fromList = sessionStorage.getItem(FROM_LIST_KEY) === '1'
          sessionStorage.removeItem(FROM_LIST_KEY)
          if (fromList) {
            this.cleanupBackIntercept()
            return
          }
          // 直接进入活动详情页（如 app 直接打开详情链接）：pushState 哨兵拦截返回键
          // 按返回键时浏览器先 back 到哨兵（URL 不变），触发 popstate，由 onBackIntercept 跳转到活动列表
          if (this.backIntercepted) return
          try {
            history.pushState({ backIntercept: true }, '', location.href)
            this.backIntercepted = true
            window.addEventListener('popstate', this.onBackIntercept)
          } catch (e) {
            // pushState 失败时静默降级，不影响正常浏览
          }
        },
        // 返回键拦截回调：跳转到活动列表（带签名参数）
        onBackIntercept() {
          if (!this.backIntercepted) return
          this.cleanupBackIntercept()
          this.$router.replace({
            path: ACTIVITY_LIST_PATH,
            query: buildAuthQuery(this.$route.query)
          })
        },
        // 清理返回键拦截
        cleanupBackIntercept() {
          if (this.backIntercepted) {
            window.removeEventListener('popstate', this.onBackIntercept)
            this.backIntercepted = false
          }
        },
        // 监听 pageshow：从 BFCache 恢复时强制刷新活动页面
        // 安卓 WebView 后退/前进时可能命中 BFCache，event.persisted 为 true 表示未重新执行 JS
        onPageShow(event) {
          if (!event.persisted) return
          const path = this.$route.path || ''
          if (this.isActivityRoute(path)) {
            window.location.reload()
          }
        },
        // 监听 visibilitychange：从后台切回前台时强制刷新活动页面
        // 安卓 app 切后台再切回，WebView 不会重新加载页面，需要手动刷新
        onVisibilityChange() {
          if (document.visibilityState !== 'visible') return
          const path = this.$route.path || ''
          if (this.isActivityRoute(path)) {
            window.location.reload()
          }
        },
      },
      watch: {
        $route(to) {
          // 进入活动列表页时设置标志，供后续详情页判断是否需要拦截返回键
          if (to.path === ACTIVITY_LIST_PATH) {
            sessionStorage.setItem(FROM_LIST_KEY, '1')
          }
          // 根据目标路由设置返回键拦截
          this.setupBackIntercept(to.path)
        }
      },
      created() {
        window.addEventListener('resize', this.getHeight);
        this.getHeight()
        // 注册 BFCache 恢复监听
        window.addEventListener('pageshow', this.onPageShow)
        // 注册后台切前台监听（安卓 WebView 常见场景）
        document.addEventListener('visibilitychange', this.onVisibilityChange)
        // 初始路由处理：首屏直接进入时 watch 不会触发，需手动设置一次
        this.$nextTick(() => {
          const path = this.$route.path || ''
          if (path === ACTIVITY_LIST_PATH) {
            sessionStorage.setItem(FROM_LIST_KEY, '1')
          }
          this.setupBackIntercept(path)
        })
      },
      beforeDestroy() {
        window.removeEventListener('pageshow', this.onPageShow)
        document.removeEventListener('visibilitychange', this.onVisibilityChange)
        this.cleanupBackIntercept()
      },
      computed: {
        closingPage() {
          return this.$store.state.closingPage
        },
      },
    }
</script>
<style></style>


